var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-infolist"},_vm._l((_vm.info),function(item,i){return _c('div',{key:i,staticClass:"ui-infolist__item"},[_c('ui-infolist-item',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }